export default __webpack_public_path__ + "static/media/Video_2.14b0bc44.mp4";